.icon {
  display: flex;
  align-items: center;
}
